@use '../../../../assets/styles/utilities.scss';

:host {
  display: block;
}
